import { useContext } from "react";
import { SelffixLoadingContext } from "../../contexts/SelffixLoadingContext";
import { selfixLoaderIcon } from "../../assets";
import "./index.css";

export const SelffixLoading = () => {
  const { isLoading } = useContext(SelffixLoadingContext);
  if (!isLoading) return null;

  return (
    <div className="selffix-loading-container">

      <div className="selffix-loading">
        <img src={selfixLoaderIcon} alt="selffix-loader" />
      </div>

    </div>
  );
};